import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { statistics } from "@/data/content";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n.toLocaleString("de-DE")}
      {suffix}
    </span>
  );
};

const Statistics = () => (
  <section className="grain relative bg-fw-charcoal py-20 md:py-28" data-testid="statistics-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <div className="mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <h2 className="font-technical uppercase font-bold text-4xl md:text-5xl text-white">
          {statistics.title}
        </h2>
        <p className="font-body text-fw-gold text-sm md:text-base">{statistics.einsatzgebiet}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {statistics.items.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.6 }}
            className="bg-fw-charcoal p-6 md:p-10"
            data-testid={`stat-${i}`}
          >
            <div className="font-technical font-black text-4xl md:text-6xl text-fw-gold leading-none">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-3 font-body text-white/60 text-sm md:text-base uppercase tracking-wide">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Statistics;
